import { getImageThumbnailUrl } from '@/utils/getImageThumbnailUrl';
import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ReactImageMagnify from 'react-image-magnify';
import { DEFAULT_IMAGE_OBJECT, MEDIA_TYPES } from '../../../../utils/constants';

import {
  DesktopComponentContainer,
  DesktopComponentMainImageContainer,
  MainImageVideoIconContainer,
  SideImagePanelContainer,
  ShareActionsContainer,
  MagnifyImageContainer,
  ShareIconContainer,
  ShareOptionsContainer,
  SharOptionsBlock,
  SharOptionsSection,
  PortalContainer,
} from './DesktopImageComponent.styles';
import { PlayIcon } from '@/assets/svgExports/PlayIcon';
import { ShareIcon } from '@/assets/svgExports/ShareIcon';
import {
  copyTextToClipboard,
  generateFacebookShareURL,
  generateTelegramShareLink,
  generateTwitterWebIntentURL,
  generateWhatsAppShareURL,
} from '../../../../utils/generateShareableURLS';
import { getSrcSetFromCompressedImages } from '../../../../utils/compressedImagesHelpers';
import { SHARE_OPTIONS, SIDE_PANEL_MAX_IMAGE_LIMIT } from './constants';
import {
  getImageDimensions,
  getThumbnailImageDimensions,
  getEnlargedImageContainerDimensions,
  getZoomedImageDimension,
} from './utils';
import { isThemeCustomizableForStore } from 'src/utils/isThemeCustomizableForStore';
import { SidePanelImages } from './SidePanelImages';
import { MediaContainer } from 'src/components/ProductMediaRenderer/MediaContainer';

function DesktopImageComponent(props) {
  const {
    theme: { product_aspect_ratio: aspectRatio },
  } = useSelector((state) => ({
    theme: state.storeReducer.store.theme,
  }));
  const isAspectRatioAllowed = isThemeCustomizableForStore();

  const imageDimensions = getImageDimensions(aspectRatio, isAspectRatioAllowed);
  const enlargedImageContainerDimensions = getEnlargedImageContainerDimensions(
    aspectRatio,
    isAspectRatioAllowed
  );
  const thumbnailImageDimensions = getThumbnailImageDimensions(
    aspectRatio,
    isAspectRatioAllowed
  );
  const zoomedImageDimensions = getZoomedImageDimension(
    aspectRatio,
    isAspectRatioAllowed
  );
  // const playIconPosition = getPlayIconPosition(aspectRatio, isAspectRatioAllowed);

  const { handleShowImageDescriptionModal, productData, activeIdx } = props;
  const [sidePanelImages, setSidePanelImages] = useState([]);
  const [mainImage, setMainImage] = useState();

  const [selectedVariant, setSelectedVariant] = useState(
    productData?.variants?.[activeIdx] || {}
  );

  const imageRef = useRef();
  const shareRef = useRef();

  useEffect(() => {
    handleSidePanelImages();
  }, [productData, selectedVariant]);

  useEffect(() => {
    !!sidePanelImages?.length && setMainImage(sidePanelImages[0]);
  }, [sidePanelImages]);

  useEffect(() => {
    if (activeIdx !== -1) setSelectedVariant(productData?.variants?.[activeIdx]);
  }, [activeIdx]);

  useEffect(() => {
    imageRef?.current
      ?.getElementsByTagName('img')?.[0]
      ?.setAttribute('property', 'image');
  }, [productData?.name]);

  useEffect(() => {
    props?.setMainImageIndexFromPdp(
      sidePanelImages.findIndex((item) => item?.image_url === mainImage?.image_url)
    );
  }, [mainImage]);

  useEffect(() => {
    const handler = (e) => {
      if (shareRef.current && !shareRef.current.contains(e.target)) {
        setShowAction(false);
      }
    };
    document.addEventListener('click', handler);
    return () => {
      document.removeEventListener('click', handler);
    };
  });

  function handleSidePanelViewMore(e) {
    e?.stopPropagation();
    if (mainImage?.image_url === DEFAULT_IMAGE_OBJECT.image_url) return;
    handleShowImageDescriptionModal();
  }

  function setImagesifVariantNotPresent() {
    if (!productData?.images?.length) {
      setSidePanelImages([DEFAULT_IMAGE_OBJECT]);
    } else {
      setSidePanelImages(productData?.images);
    }
  }

  function setImagesifVariantPresent() {
    if (productData?.variants?.length) {
      let tempImages = !!selectedVariant?.images
        ? selectedVariant?.images.slice(0, SIDE_PANEL_MAX_IMAGE_LIMIT)
        : [];
      if (productData?.images && productData?.images?.length) {
        if (tempImages?.length) tempImages = tempImages.concat(productData?.images);
        else tempImages = productData?.images?.slice(0, productData?.images?.length);
      }
      if (!tempImages?.length) tempImages?.push(DEFAULT_IMAGE_OBJECT);
      setSidePanelImages(tempImages);
    } else {
      const tempImages = productData?.images?.slice(0, productData?.images?.length);
      setSidePanelImages(tempImages);
    }
  }

  function handleSidePanelImages() {
    if (!productData?.variants_count) {
      setImagesifVariantNotPresent();
    } else {
      setImagesifVariantPresent();
    }
  }

  function handleSidePanelImage(item) {
    if (
      item?.media_type === MEDIA_TYPES.YOUTUBE_VIDEO ||
      item?.media_type === MEDIA_TYPES.VIDEO
    ) {
      handleShowImageDescriptionModal();
    }
    setMainImage(item);
  }

  function handleMainImageView(item) {
    if (item?.media_type === MEDIA_TYPES.YOUTUBE_VIDEO) {
      return getImageThumbnailUrl(item);
    }
    return item?.image_url;
  }
  const [showAction, setShowAction] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const handleParentEvent = (e) => {
    e.stopPropagation();
  };
  const handleShareButtonAction = (e) => {
    setShowAction((state) => !state);
    setIsCopied(false);
  };
  const handleShareOptionAction = (choice) => {
    switch (choice) {
      case 'Copy Link':
        copyTextToClipboard(window.location.href, setIsCopied);
        break;
      case 'Facebook':
        {
          const url = generateFacebookShareURL(
            window.location.href,
            productData?.name,
            choice
          );
          window.open(url);
        }
        break;
      case 'Whatsapp':
        {
          const url = generateWhatsAppShareURL(
            window.location.href,
            productData?.name,
            choice
          );
          window.open(url);
        }
        break;
      case 'Twitter':
        {
          const url = generateTwitterWebIntentURL(
            window.location.href,
            productData?.name,
            choice
          );
          window.open(url);
        }
        break;
      case 'Telegram': {
        const url = generateTelegramShareLink(
          window.location.href,
          productData?.name,
          choice
        );
        window.open(url);
      }
      default:
        console.error('Please Select a valid option');
    }
  };
  return (
    <DesktopComponentContainer
      isCustomWebsite={isAspectRatioAllowed}
      className="tw-mx-auto"
    >
      <SideImagePanelContainer>
        <SidePanelImages
          sidePanelImages={sidePanelImages}
          thumbnailImageDimensions={thumbnailImageDimensions}
          mainImage={mainImage}
          handleSidePanelViewMore={handleSidePanelViewMore}
          handleSidePanelImage={handleSidePanelImage}
        />
      </SideImagePanelContainer>
      <MediaContainer
        width={imageDimensions.width}
        containerClasses="tw-ml-[16px] !tw-overflow-visible"
      >
        <DesktopComponentMainImageContainer
          ref={imageRef}
          isCustomWebsite={isAspectRatioAllowed}
          imageDimensions={imageDimensions}
          mediaType={mainImage?.media_type}
          onClick={handleSidePanelViewMore}
        >
          <MagnifyImageContainer>
            <ShareActionsContainer ref={shareRef} onClick={handleParentEvent}>
              <ShareIconContainer onClick={handleShareButtonAction}>
                <ShareIcon />
              </ShareIconContainer>
              {showAction && (
                <ShareOptionsContainer>
                  {SHARE_OPTIONS.map(({ id, portal, logo }, idx) => (
                    <SharOptionsBlock
                      key={id}
                      lastIdx={
                        idx + 1 === SHARE_OPTIONS.length ? SHARE_OPTIONS.length : ''
                      }
                    >
                      <SharOptionsSection onClick={() => handleShareOptionAction(portal)}>
                        <img src={logo} />
                        <PortalContainer
                          portal={
                            portal === 'Copy Link' && isCopied ? 'Link Copied' : portal
                          }
                        >
                          {portal === 'Copy Link' && isCopied ? 'Link Copied' : portal}
                        </PortalContainer>
                      </SharOptionsSection>
                    </SharOptionsBlock>
                  ))}
                </ShareOptionsContainer>
              )}
            </ShareActionsContainer>
            {(mainImage?.image_url || mainImage?.thumbnail_url) &&
              (mainImage?.media_type !== MEDIA_TYPES.VIDEO ? (
                <ReactImageMagnify
                  {...{
                    className: '!tw-h-full !tw-w-full !tw-overflow',
                    smallImage: {
                      alt: mainImage?.alt_text || productData?.name,
                      src: handleMainImageView(mainImage),
                      srcSet: getSrcSetFromCompressedImages(
                        mainImage?.compressed_images,
                        handleMainImageView(mainImage)
                      ),
                      isFluidWidth: true,
                    },
                    largeImage: {
                      src: handleMainImageView(mainImage),
                      ...zoomedImageDimensions,
                    },
                    enlargedImageContainerDimensions,
                    enlargedImageContainerStyle: {
                      backgroundColor: '#ffffff',
                      zIndex: 10,
                      marginLeft: 42,
                      boxShadow: '0 0 24px rgba(0,0,0,0.34)',
                      borderRadius: 16,
                      display:
                        mainImage?.image_url === DEFAULT_IMAGE_OBJECT.image_url
                          ? 'none'
                          : '',
                    },
                    enlargedImageStyle: {
                      objectFit: 'cover',
                      maxWidth: 1000,
                      display:
                        mainImage?.image_url === DEFAULT_IMAGE_OBJECT.image_url
                          ? 'none'
                          : '',
                    },
                    lensStyle: {
                      display:
                        mainImage?.image_url === DEFAULT_IMAGE_OBJECT.image_url
                          ? 'none'
                          : '',
                    },
                    imageClassName: '!tw-object-contain !tw-w-full !tw-h-full',
                    shouldUsePositiveSpaceLens: true,
                  }}
                />
              ) : (
                <img
                  src={mainImage?.thumbnail_url}
                  className="tw-h-full tw-w-full tw-object-contain"
                />
              ))}
          </MagnifyImageContainer>
          {(mainImage?.media_type === MEDIA_TYPES.YOUTUBE_VIDEO ||
            mainImage?.media_type === MEDIA_TYPES.VIDEO) && (
            <MainImageVideoIconContainer>
              <PlayIcon height={64} width={64} />
            </MainImageVideoIconContainer>
          )}
        </DesktopComponentMainImageContainer>
      </MediaContainer>
    </DesktopComponentContainer>
  );
}

export default DesktopImageComponent;
